export enum WaterTransferAssetType {
    Attachment,
    EmailAttachment,
    TransferDocument,
    MeterPictures,
    IDCardPictures,
}
